<template>
  <div class="design-quality-details">
    <div class="w">
      <div class="title">
        <span class="text" v-if="isShower == '1'" @click="goBackRoom" style="cursor: pointer;">定制淋浴房</span>
        <span class="text" v-else @click="goBack" style="cursor: pointer;">更多产品</span>
        <span style="vertical-align: middle">
          <img src="../assets/img/dulles/right.png" alt="" />
        </span>
        <span class="text">{{ categoryName }}</span>
      </div>
      <div
        class="content"
        v-for="(item, index) of list"
        :key="item.id"
        v-show="currentIndex === index"
      >
        <div
          class="content-left"
          :class="{ 'modified-left': isShow == true }"
          @click="left"
        >
          <img src="../assets/img/dulles/shower-left.png" alt="" />
        </div>
        <div class="content-img">
          <img :src="getImageURL(item.url)" alt="" />
          <div class="top-text">{{ item.imgName }}</div>
          <div class="bottom-text">{{ item.subTitle }}</div>
        </div>
        <div
          class="content-right"
          @click="right"
          :class="{ 'modified-right': isShows == true }"
        >
          <img src="../assets/img/dulles/shower-right.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baseURL } from "../utils/index.js";
export default {
  name: "ShowerRoomDetail",
  components: {},
  data() {
    return {
      id: this.$route.query.id || "", //淋浴房ID
      ids: this.$route.query.ids || "", //更多产品id
      categoryName: this.$route.query.name || "",
      isShower: this.$route.query.isShower || 0,
      list: [
        // {
        //   id: 1,
        //   url: url,
        //   name: '弧顶式一字型淋浴房',
        //   text: '伏尔加河系列-弧顶式'
        // },
        // {
        //   id: 2,
        //   url: urls,
        //   name: '弧顶式二字型淋浴房',
        //   text: '伏尔加二河系列-弧顶式'
        // }
      ], //淋浴房详情
      currentIndex: 0,
      isShow: false,
      isShows: false,
    };
  },
  mounted() {
    if (this.isShower == 1) {
      // 1淋浴房
      this.showerRoom();
    } else {
      // 0更多产品
      this.editRoom();
    }
  },
  watch: {
    "$route.query.id": function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.id = newValue;
        this.showerRoom();
      }
    },
    "$route.query.ids": function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.ids = newValue;
        this.editRoom();
      }
    },
    "$route.query.name": function (newValue) {
      this.categoryName = newValue;
    },
    "$route.query.isShower": function (newValue,) {
      this.isShower = newValue;
    },
    immediate: true,
  },
  methods: {
    getImageURL(image) {
      return baseURL + image;
    },
    // 淋浴房查询
    showerRoom() {
      this.list = [];
      this.$http
        .get(`resource/listImgsByCagegory`, {
          params: {
            cid: this.id,
          },
        })
        .then((res) => {
          if (res.data.code == "success") {
            if (res.data.data.length <= 1) {
              this.isShows = true;
            } else {
              this.isShows = false;
            }
            this.list = res.data.data;
          }
        });
    },
    // 更多产品
    editRoom() {
      this.list = [];
      this.$http
        .get(`resource/listImgsByCagegory`, {
          params: {
            cid: this.ids,
          },
        })
        .then((res) => {
          if (res.data.code == "success") {
            if (res.data.data.length <= 1) {
              this.isShows = true;
            }
            this.list = res.data.data;
          }
        });
    },
    // 左测图
    left() {
      if (this.currentIndex > 1) {
        this.currentIndex--;
        this.isShows = false;
      } else if (this.currentIndex == 1) {
        this.currentIndex--;
        this.isShow = false;
        this.isShows = false;
      } else {
        return
      }
    },
    // 右侧图
    right() {
      if (this.currentIndex < this.list.length - 1 && this.list.length > 1) {
        this.currentIndex++;
        this.isShow = true;
        if (this.currentIndex == this.list.length - 1) {
          this.isShows = true;
          return;
        }
      } else {
        return
      }
    },
    // 更多产品返回上一页
    goBack(){
      this.$router.go(-1)
    },
    // 定制淋浴房返回首页
    goBackRoom(){
      this.$router.push({ path: "/"});
    },
  },
};
</script>

<style lang="scss" scoped>
.design-quality-details {
  min-height: 88vh;
  background: #f2f2f2;

  .title {
    margin: 32px 0;
    font-size: 20px;
    vertical-align: middle;

    img {
      vertical-align: middle;
      margin: 0 10px;
      width: 22px;
    }

    .text {
      vertical-align: middle;
    }
  }

  .content {
    width: 100%;
    background: #ffffff;
    padding: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;

    .content-left {
      width: 44px;
      height: 44px;
      border-radius: 44px;
      background: rgba(0, 0, 0, 0.23);
      text-align: center;
      line-height: 48px;
      cursor: pointer;

      img {
        text-align: center;
      }
    }

    .modified-left {
      background: rgba(0, 0, 0, 0.7);
    }

    .content-img {
      width: 1032px;

      img {
        width: 100%;
        border-radius: 12px;
      }

      .top-text {
        margin: 25px 0 16px;
        color: #100d24;
        font-weight: bold;
        font-size: 26px;
      }

      .bottom-text {
        color: #8b8c8f;
        font-size: 18px;
      }
    }

    .content-right {
      width: 44px;
      height: 44px;
      border-radius: 44px;
      background: rgba(0, 0, 0, 0.7);
      text-align: center;
      line-height: 48px;
      cursor: pointer;

      img {
        text-align: center;
        width: 16px;
      }
    }

    .modified-right {
      background: rgba(0, 0, 0, 0.23);
    }
  }
}
</style>